import { onMounted, provide, inject, ref } from '@nuxtjs/composition-api';
import { SPONSORED } from '~/constants/config';
import { hasQuestion } from '~/modules/article/utils/articleUtils';

export const initiliazeArticleEvents = (article) => {
  onMounted(() => {
    const categoryNames = ref([]);
    const labelName = ref(null);
    const adConfig = inject('adConfig');
    const decidedMode = adConfig?.value?.decidedMode?.value;

    provide('eventConfig', {
      categoryNames,
      labelName,
      legacyId: article.value.legacyId,
      isTest: article.value?.flags?.isTest,
      isSponsored: SPONSORED.some((i) => article.value?.tags?.includes(i)) ? 'Evet' : 'Hayır',
      isSponsoredCategory: decidedMode === 'sponsored' ? 'Evet' : 'Hayır',
    });

    const mainCategory = article.value.categories.find((cat) => cat.parent === undefined) || {};
    if (mainCategory.name === 'Vitrin') {
      categoryNames.value.push(`Shopping - ${article.value.legacyId}`);
    }
    if (decidedMode === 'PremiumUser') {
      const authorName = article.value.authors[0].name || article.value.authors[0].username;
      categoryNames.value.push(`${authorName.replace(/\s+/g, '')} - ${article.value.legacyId}`);
    }
    if (decidedMode === 'sponsored' && adConfig.value.sponsoredTag.eventName) {
      categoryNames.value.push(adConfig.value.sponsoredTag.eventName);
      labelName.value = article.value.legacyId;
    }
    if (categoryNames.value.length === 0) {
      categoryNames.value.push(`Icerik - ${article.value.legacyId}`);
    }
    if (hasQuestion(article.value)) {
      window.oio.init(function () {
        const $ = window.$;
        if (article.value.tags.includes('~test-analytics')) {
          $(`article.article[data-legacy-id='${article.value.legacyId}'] section.question div.answer`).one('click tap', function () {
            const questionNumber = $('section.question').index($(this).closest('section'));
            const actionName = questionNumber + 1 + '. soru';
            const answerText = $(this).find('h5').text().trim();
            const answerNumber = $(this).index() + 1;
            const label = answerText.length ? answerText : answerNumber + '. şık';
            categoryNames.value.forEach((categoryName) => {
              window.gtag('event', actionName, {
                event_category: categoryName,
                event_label: label,
              });
            });
          });
        }
        $(`article.article[data-legacy-id='${article.value.legacyId}']`).on('testFinish', function (e) {
          setTimeout(function () {
            const title = $(
              `article.article[data-legacy-id='${article.value.legacyId}'] section[data-question-result][data-question-result!='*']:visible h2`
            )
              .first()
              .text()
              .trim();
            categoryNames.value.forEach((categoryName) => {
              window.gtag('event', 'Test Sonuc', {
                event_category: categoryName,
                event_label: title,
              });
            });
          }, 30);
        });
      });
    }
  });
};
export const initiliazeEntryEvents = (entryElementRef) => {
  onMounted(() => {
    const { categoryNames, labelName, legacyId, isTest, isSponsored, isSponsoredCategory } = inject('eventConfig');
    const entryElement = entryElementRef.value.parentElement;
    const entryDesc = ref('');
    const questionResult = entryElement.dataset.questionResult;
    const validSections = document.querySelectorAll(
      `article.article[data-legacy-id='${legacyId}'] section.entry:not(.entry--html):not(.entry--oio-embed)`
    );
    const validSectionsArray = Array.from(validSections);
    const entryIndex = validSectionsArray.findIndex((el) => el === entryElement);
    const titleElement = entryElement.querySelector('h2');
    const title = titleElement ? titleElement.textContent.trim() : undefined;
    const entryNumber = entryIndex === validSections.length - 1 ? 'Son' : entryIndex === 0 ? 'İlk' : entryIndex + 1;
    if (title) {
      const titleSplit = title.split('.');
      const isTitleNumbered = !isNaN(titleSplit[0]);
      if (isTitleNumbered) {
        entryDesc.value = 'Entry - ' + title.slice(0, title.indexOf('.'));
      } else {
        const words = title.split(' ').splice(0, 4);
        entryDesc.value = 'Entry - ' + words.join(' ');
      }
    } else {
      entryDesc.value = 'Entry - ' + entryNumber;
    }
    const titleClickElement = entryElement.querySelector('h2 a');
    const imageClickElement = entryElement.querySelector('div.image a');
    const linkClickElements = entryElement.querySelectorAll('a.external-link');

    const vitrinClickEvent = (actionName) => {
      window.dataLayer.push({
        event: 'vitrin_click',
        isSponsored, // İçeriğin sponsorlu olma durumuna göre Evet ya da Hayır olarak dönecek.
        isSponsoredCategory, // İçeriğin kategorisinin sponsorlu olma durumuna göre Evet ya da Hayır olarak dönecek.
        event_category: 'Vitrin', // Sabit olarak bu değer gelecek.
        event_action: 'Click', // Sabit olarak  bu değer gönderilecek.
        event_label: actionName, // Entry - 3 ya da Link 1 Click (tıklayın) gibi ifadeler gelecek.
        content_id: legacyId, // İçerik ID bilgisi gelecek.
      });
    };

    const affClickEvent = (actionName) => {
      window.dataLayer.push({
        event: 'aff_click',
        event_category: isTest ? 'Sponsorlu Quiz' : 'Sponsorlu Liste', // Sponsorlu Liste veya Sponsorlu Quiz olarak gelecek.
        event_action: 'Click', // Sabit olarak  bu değer gönderilecek.
        event_label: actionName, // Entry bilgisi ya da CTA bilgisi gelecek. Örnek: Sonuc Detay Link 1 Click (Mitsubishi Electric)
        content_id: legacyId, // İçerik ID bilgisi gelecek. Örnek: 1188862
      });
    };

    categoryNames.value.forEach((categoryName) => {
      if (titleClickElement) {
        let actionName;
        if (questionResult !== undefined) {
          actionName = questionResult === '*' ? 'Baglama Baslik Click' : 'Sonuc Baslik Click';
        } else if (entryNumber === 'Son' && !categoryName.includes('Shopping -')) {
          actionName = `Baglama Baslik Click`;
        } else {
          actionName = `${entryDesc.value} - Baslik Click`;
        }
        titleClickElement.addEventListener('click', () => {
          if (categoryName.includes('Shopping -')) {
            vitrinClickEvent(actionName);
          } else {
            affClickEvent(actionName);
          }
          window.gtag('event', actionName, {
            event_category: categoryName,
            ...(labelName.value && { event_label: labelName.value }),
          });
        });
      }
      if (imageClickElement) {
        let actionName;
        if (questionResult !== undefined) {
          actionName = questionResult === '*' ? 'Baglama Gorseli Click' : 'Sonuc Gorsel Click';
        } else if (entryNumber === 'Son' && !categoryName.includes('Shopping -')) {
          actionName = `Baglama Gorsel Click`;
        } else {
          actionName = `${entryDesc.value} - Gorsel Click`;
        }
        imageClickElement.addEventListener('click', () => {
          if (categoryName.includes('Shopping -')) {
            vitrinClickEvent(actionName);
          } else {
            affClickEvent(actionName);
          }
          window.gtag('event', actionName, {
            event_category: categoryName,
            ...(labelName.value && { event_label: labelName.value }),
          });
        });
      }
      if (linkClickElements.length > 0) {
        linkClickElements.forEach((link, index) => {
          let actionName;
          if (questionResult !== undefined) {
            actionName =
              questionResult === '*'
                ? `CTA Link ${index + 1} Click (${link.textContent.split(' ').splice(0, 4).join(' ')})`
                : `Sonuc Detay Link ${index + 1} Click (${link.textContent.split(' ').splice(0, 4).join(' ')})`;
          } else if (entryNumber === 'Son' && !categoryName.includes('Shopping -')) {
            actionName = `CTA Link ${index + 1} Click (${link.textContent.split(' ').splice(0, 4).join(' ')})`;
          } else {
            actionName = `${entryDesc.value} - Link ${index + 1} Click (${link.textContent.split(' ').splice(0, 4).join(' ')})`;
          }
          link.addEventListener('click', () => {
            if (categoryName.includes('Shopping -')) {
              vitrinClickEvent(actionName);
            } else {
              affClickEvent(actionName);
            }
            window.gtag('event', actionName, {
              event_category: categoryName,
              ...(labelName.value && { event_label: labelName.value }),
            });
          });
        });
      }
    });
  });
};
